module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/bookingWindow.svg?80b1b36d";